module.exports = __webpack_public_path__ + "static/media/Neville Longbottom 1.dbbaa3a4.jpg";